var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewStarsGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 20,
    viewBox: "0 0 108 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 -0.000976562H0V19.999H20V-0.000976562ZM11.9468 8.06906L10 3.49902L8.05319 8.06906L3 8.46457L6.85001 11.6845L5.67377 16.499L10 13.919L14.3262 16.499L13.15 11.6845L17 8.46457L11.9468 8.06906Z",
    fill: "#04BA71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 -0.000976562H22V19.999H42V-0.000976562ZM33.9468 8.06906L32 3.49902L30.0532 8.06906L25 8.46457L28.85 11.6845L27.6738 16.499L32 13.919L36.3262 16.499L35.15 11.6845L39 8.46457L33.9468 8.06906Z",
    fill: "#04BA71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 -0.000976562H64V19.999H44V-0.000976562ZM54 3.49902L55.9468 8.06906L61 8.46457L57.15 11.6845L58.3262 16.499L54 13.919L49.6738 16.499L50.85 11.6845L47 8.46457L52.0532 8.06906L54 3.49902Z",
    fill: "#04BA71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 -0.000976562H66V19.999H86V-0.000976562ZM77.9468 8.06906L76 3.49902L74.0532 8.06906L69 8.46457L72.85 11.6845L71.6738 16.499L76 13.919L80.3262 16.499L79.15 11.6845L83 8.46457L77.9468 8.06906Z",
    fill: "#04BA71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 -0.000976562H108V19.999H88V-0.000976562ZM98 3.49902L99.9468 8.06906L105 8.46457L101.15 11.6845L102.326 16.499L98 13.919L93.6738 16.499L94.85 11.6845L91 8.46457L96.0532 8.06906L98 3.49902Z",
    fill: "#04BA71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStarsGreen);
export default __webpack_public_path__ + "static/media/review_stars_green.6ff69428a087778e33e1ac9c9463f001.svg";
export { ForwardRef as ReactComponent };